import {
  Button,
  Card,
  Col,
  Input,
  Pagination,
  Row,
  Spin,
  Table,
  Tag,
  Space,
  Popconfirm,
  Select,
  App,
} from "antd";
import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  ArrowUpOutlined,
  BarChartOutlined,
  DeleteFilled,
  DownloadOutlined,
  EyeOutlined,
  FileExclamationOutlined,
  GlobalOutlined,
  LoadingOutlined,
  MailOutlined,
  PlusOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import debounce from "lodash.debounce";
import {
  CAMPAIGN_SUMMARY,
  DOWNLOAD_CAMPAIGN,
  LIST_CAMPAIGN,
  SOFT_DELETE,
} from "../../apis/apis";
import CulsightPageLoader from "../../components/CulsightPageLoader";
import { formatToIST } from "../../../helper/CommonHelper";

function Campaign() {
  const location = useLocation();
  const { message } = App.useApp();
  const { notification } = App.useApp();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(true);
  const [pagination_loader, set_pagination_loader] = useState(false);
  const [table_data, set_table_data] = useState([]);
  const [total_pages, set_total_pages] = useState("");
  const [total_campaigns, set_total_campaigns] = useState("");
  const [lastPageBeforeSearch, setLastPageBeforeSearch] = useState(1);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  // CAMPAIGN SUMMARY STATES
  const [total_sent, set_total_sent] = useState("");
  const [total_users, set_total_users] = useState("");
  const [total_campaign, set_total_campaign] = useState("");
  const [active_campaign, set_active_campaign] = useState("");

  const [current_page, set_current_page] = useState(
    Number(localStorage.getItem("campaign_page")) || 1
  );

  const [page_size, set_page_size] = useState(
    Number(localStorage.getItem("campaign_page_size")) || 10
  );

  const [search_query_name, set_search_query_name] = useState(
    localStorage.getItem("campaign_search") || ""
  );

  const [search_type, set_search_type] = useState(
    localStorage.getItem("campaign_search_type") || "name"
  );

  // LIST API
  const LIST_API = async (page = current_page, size = page_size, search = search_query_name, type = search_type) => {
    const FORM_DATA = new FormData();
    FORM_DATA.append("per_page", size);
    FORM_DATA.append("page", page);

    FORM_DATA.append("name", "");
    FORM_DATA.append("email_template_name", "");
    FORM_DATA.append("group_name", "");

    if (search) {
      FORM_DATA.append(type, search);
    }

    const API_CALL = await LIST_CAMPAIGN(FORM_DATA);
    if (API_CALL?.data?.status) {
      set_table_data(API_CALL?.data?.data);
      set_current_page(API_CALL?.data?.current_page);
      set_total_pages(API_CALL?.data?.total_pages);
      set_total_campaigns(API_CALL?.data?.total_campaigns);
      setLoader(false);
    } else {
      console.log("error");
      setLoader(false);
    }
  };

  useEffect(() => {
    LIST_API(
      Number(localStorage.getItem("campaign_page")) || 1,
      Number(localStorage.getItem("campaign_page_size")) || 10,
      localStorage.getItem("campaign_search") || "",
      localStorage.getItem("campaign_search_type") || "name"
    );
  }, []);

  // SEARCH API


  const handleInput = (e) => {
    const value = e.target.value;

    if (value && !search_query_name) {
      localStorage.setItem(
        "campaign_last_search_page",
        current_page
      );
    }

    set_search_query_name(value);

    localStorage.setItem(
      "campaign_search",
      value
    );

    clearTimeout(window.campaignSearchTimer);

    window.campaignSearchTimer = setTimeout(() => {

      const pageToLoad = value
        ? 1
        : Number(
          localStorage.getItem(
            "campaign_last_search_page"
          )
        ) || 1;

      set_current_page(pageToLoad);

      LIST_API(
        pageToLoad,
        page_size,
        value,
        search_type
      );

    }, 500);
  };

  const handleDelete = async (id) => {
     setLoader(true); 
    const FORM_DATA = new FormData();
    FORM_DATA.append("id", id);

    try {
      const response = await SOFT_DELETE(FORM_DATA);

      if (response?.data?.status) {
        notification.success({
          message: "Success",
          description:
            response?.data?.message || "Campaign deleted successfully",
        });

        await LIST_API(current_page, page_size, search_query_name, search_type);
        await CAMPAIGN_SUMMARY_LIST();
      } else {
        notification.error({
          message: "Error",
          description: response?.data?.message || "Failed to delete campaign",
        });
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: "Something went wrong",
      });
      
    }
    finally {
  setLoader(false);
}
  };
  //bulk delete handler
  const handleBulkDelete = async () => {
    setLoader(true);
    try {
      const FORM_DATA = new FormData();
      //console.log("Delete IDs:", selectedRowKeys.join(","));
      // Convert selected ids into comma separated string
      FORM_DATA.append("ids", selectedRowKeys.join(","));

      //console.log("delete_IDs:", FORM_DATA.get("campaign_id"));

      const response = await SOFT_DELETE(FORM_DATA);

      if (response?.data?.status) {
        notification.success({
          message: "Success",
          description: response?.data?.message,
        });

        setSelectedRowKeys([]);
        await LIST_API(current_page, page_size, search_query_name, search_type);
        await CAMPAIGN_SUMMARY_LIST();
      } else {
        notification.error({
          message: "Error",
          description: response?.data?.message,
        });
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: "Failed to delete campaigns",
      });
    }
    finally {
  setLoader(false);
}
  };

  //Bulk download handler
  const handleBulkDownload = async () => {
      setLoader(true);
    try {
      const FORM_DATA = new FormData();
      //console.log(selectedRowKeys.join(","));
      // Convert selected ids into comma separated string
      FORM_DATA.append("campaign_ids", selectedRowKeys.join(","));
      //console.log("campaign_id:", FORM_DATA.get("campaign_id"));
      const response = await DOWNLOAD_CAMPAIGN(FORM_DATA);

      if (response?.data?.status) {
        notification.success({
          message: "Success",
          description: response?.data?.message,
        });

        setSelectedRowKeys([]);
        await LIST_API(current_page, page_size, search_query_name, search_type);
        await CAMPAIGN_SUMMARY_LIST();
      } else {
        notification.error({
          message: "Error",
          description: response?.data?.message,
        });
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: "Failed to download campaigns",
      });
    }
    finally {
  setLoader(false);
}
  };

  // Stop campaign
  // const stopcampaign = async (id) => {
  //   const FORM_DATA = new FormData();
  //   FORM_DATA.append("id", id);

  //   try {
  //     const response = await SOFT_DELETE(FORM_DATA);
  //     if (response?.data?.status) {
  //       message.success("Campaign deleted successfully");
  //       LIST_API(); // refresh list
  //     } else {
  //       notification.error({
  //         message: "Failed",
  //         description: response?.data?.message ,
  //         placement: "topRight",
  //       });
  //     }
  //   } catch (error) {

  //     notification.error({
  //       message: "Failed",
  //       description: "Something went wrong",
  //       placement: "topRight",
  //     });
  //   }
  // };

  // TABLE COLUMNS
  const rowSelection = {
    selectedRowKeys,
    preserveSelectedRowKeys: true,
    onChange: (newSelectedRowKeys) => {
      setSelectedRowKeys(newSelectedRowKeys);
    },
  };
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      render: (text, record) => <span>{record.name}</span>,
    },
    {
      title: "SMTP",
      dataIndex: "smtp_name",
      render: (text, record) => <span>{record.smtp_name}</span>,
    },
    {
      title: "User Group",
      dataIndex: "group_name",
      render: (text, record) => (
        <span>
          {record.group_name} (
          {record.group_type === 1 ? "LMS Group" : "Local Group"})
        </span>
      ),
    },
    {
      title: "Email Template",
      dataIndex: "email_template_name",
      render: (text, record) => <span>{record.email_template_name}</span>,
    },
    // {
    //   title: "User Count",
    //   dataIndex: "total_users",
    //   render: (text, record) => <span>{record.total_users}</span>,
    // },

    // {
    //   title: "Created On",
    //   dataIndex: "created_at",
    //   render: (text, record) => (
    //     <span>{formatToIST(record.created_at)}</span>
    //   ),
    // },
    {
      title: "Stats",
      dataIndex: "stats",
      render: (_, record) => (
        <Space size="small">
          <Tag color="purple"
            style={{
              borderRadius: "12px",
              padding: "2px 10px",
            }}
          >
            Sent: {record.email_send || 0}
          </Tag>

          <Tag color="cyan"
            style={{
              borderRadius: "12px",
              padding: "2px 10px",
            }}
          >
            Open: {record.email_open || 0}
          </Tag>

          <Tag color="orange"
            style={{
              borderRadius: "12px",
              padding: "2px 10px",
            }}
          >
            Click: {record.email_clicked || 0}
          </Tag>
        </Space>
      ),
    },

    // {
    //   title: "Status",
    //   dataIndex: "campaign_status",
    //   render: (campaign_status) =>
    //     campaign_status ? (
    //       <Tag color="green">Active</Tag>
    //     ) : (
    //       <Tag color="red">Inactive</Tag>
    //     ),
    // },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space>
          <Button
            type="primary"
            onClick={() => {

              localStorage.setItem(
                "campaign_page",
                current_page
              );

              localStorage.setItem(
                "campaign_page_size",
                page_size
              );

              localStorage.setItem(
                "campaign_search",
                search_query_name
              );

              localStorage.setItem(
                "campaign_search_type",
                search_type
              );

              navigate("/view-campaign/" + btoa(record.id), {
                state: {
                  from: "campaign",
                  page: current_page,
                  pageSize: page_size,
                  search: search_query_name,
                },
              });
            }}
          >
            <BarChartOutlined />
          </Button>
          {/* <Popconfirm
            title="Are you sure to delete this campaign?"
            onConfirm={() => handleDelete(record.id)}
            okText="Yes"
            cancelText="No"
          >
            <Button color="red" variant="solid">
              <DeleteFilled />
            </Button>
          </Popconfirm> */}

          {/* <Popconfirm
            title="Are you sure to stop this campaign?"
            onConfirm={() => stopcampaign(record.id)}
            okText="Yes"
            cancelText="No"
          >
            <Button color='red' variant='solid'>
              <DeleteFilled />
            </Button>
 
 
          </Popconfirm> */}
          {/* <Button
            variant="solid"
            onClick={() => DOWNLOAD_CAMPAIGN_REPORT(record.id)}
            style={{ backgroundColor: "#1fa7a1", color: "#ffffff" }}
          >
            <DownloadOutlined />
          </Button> */}
        </Space>
      ),
    },
  ];

  // PAGINATION HANDLER
  const pagination_on_change = async (page, size) => {
    localStorage.setItem(
      "campaign_page",
      page
    );

    localStorage.setItem(
      "campaign_page_size",
      size
    );
    set_pagination_loader(true);
    const FORM_DATA = new FormData();
    FORM_DATA.append("page", page);
    FORM_DATA.append("per_page", size);
    FORM_DATA.append("name", "");
    FORM_DATA.append("email_template_name", "");
    FORM_DATA.append("group_name", "");

    if (search_query_name) {
      FORM_DATA.append(search_type, search_query_name);
    }
    const API_CALL = await LIST_CAMPAIGN(FORM_DATA);
    if (API_CALL?.data?.status) {
      set_table_data(API_CALL.data?.data);
      set_current_page(API_CALL?.data?.current_page);
      set_total_pages(API_CALL?.data?.total_pages);
      set_total_campaigns(API_CALL?.data?.total_campaigns);
    }
    set_pagination_loader(false);
  };

  const DOWNLOAD_CAMPAIGN_REPORT = async (id) => {
    const FORM_DATA = new FormData();
    FORM_DATA.append("campaign_ids", id);

    const response = await DOWNLOAD_CAMPAIGN(FORM_DATA);

    if (response?.data?.status) {
      notification.success({
        message: "Success",
        description:
          response?.data?.message || "Check the Download tab for your report",
      });
    } else {
      notification.error({
        message: "Error",
        description: response?.data?.message || "Failed to download report",
      });
    }
  };

  // LIST CAMPAIGN SUMMARY

  const CAMPAIGN_SUMMARY_LIST = async () => {
    const FORM_DATA = new FormData();
    const API_CALL = await CAMPAIGN_SUMMARY(FORM_DATA);
    if (API_CALL?.data?.status) {
      set_total_campaign(API_CALL?.data?.total_campaign);
      set_total_sent(API_CALL?.data?.total_sent);
      set_total_users(API_CALL?.data?.total_users);
      set_active_campaign(API_CALL?.data?.active_campaign);
      setLoader(false);
    } else {
      console.log("error");
      setLoader(false);
    }
  };

  useEffect(() => {
    CAMPAIGN_SUMMARY_LIST();
  }, []);

  return (
    <div className="lms-body">
      <Row>
        <Col span={12}>
          <h1 style={{ margin: "0px", padding: "0px" }}>Campaigns</h1>
          <span style={{ color: "gray", fontSize: "15px", fontWeight: "600" }}>
            Manage your phishing simulation campaigns
          </span>
        </Col>
        <Col span={12}>
          <Button
            type="primary"
            size="large"
            onClick={() => {

              localStorage.setItem(
                "campaign_page",
                current_page
              );

              localStorage.setItem(
                "campaign_page_size",
                page_size
              );

              localStorage.setItem(
                "campaign_search",
                search_query_name
              );

              localStorage.setItem(
                "campaign_search_type",
                search_type
              );

              navigate("/add-campaign");
            }}
            style={{ float: "right" }}
          >
            <PlusOutlined />
            Add Campaign
          </Button>
        </Col>
      </Row>

      <Row gutter={[20, 20]} style={{ marginTop: "20px" }}>
        <Col xs={24} sm={12} md={12} lg={6}>
          <Card
            hoverable
            style={{
              borderRadius: 16,
              height: 80,
              display: "flex",
              alignItems: "center",
            }}
            bodyStyle={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <div
                style={{
                  background: "#ede9fe",
                  padding: "10px",
                  borderRadius: "12px",
                  marginLeft: "-100px",
                }}
              >
                <GlobalOutlined style={{ color: "#8c3add", fontSize: 18 }} />
              </div>

              <div>
                <h2 style={{ margin: 0 }}>{total_campaign}</h2>
                <span style={{ color: "gray", fontSize: "13px" }}>
                  Total Campaigns
                </span>
              </div>
            </div>
          </Card>
        </Col>

        <Col xs={24} sm={12} md={12} lg={6}>
          <Card
            hoverable
            style={{
              borderRadius: 16,
              height: 80,
              display: "flex",
              alignItems: "center",
            }}
            bodyStyle={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <div
                style={{
                  background: "#d1fae5",
                  padding: "10px",
                  borderRadius: "12px",
                  marginLeft: "-100px",
                }}
              >
                <EyeOutlined style={{ color: "#1fa7a1", fontSize: 18 }} />
              </div>

              <div>
                <h2 style={{ margin: 0 }}>{active_campaign}</h2>
                <span style={{ color: "gray", fontSize: "13px" }}>
                  Active Campaigns
                </span>
              </div>
            </div>
          </Card>
        </Col>

        {/* Insider Risk */}
        <Col xs={24} sm={12} md={12} lg={6}>
          <Card
            hoverable
            style={{
              borderRadius: 16,
              height: 80,
              display: "flex",
              alignItems: "center",
            }}
            bodyStyle={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <div
                style={{
                  background: "#f0914d68",
                  padding: "10px",
                  borderRadius: "12px",
                  marginLeft: "-120px",
                }}
              >
                <MailOutlined style={{ color: "#f97316", fontSize: 18 }} />
              </div>

              <div>
                <h2 style={{ margin: 0 }}>{total_sent}</h2>
                <span style={{ color: "gray", fontSize: "13px" }}>
                  Total Sent
                </span>
              </div>
            </div>
          </Card>
        </Col>

        <Col xs={24} sm={12} md={12} lg={6}>
          <Card
            hoverable
            style={{
              borderRadius: 16,
              height: 80,
              display: "flex",
              alignItems: "center",
            }}
            bodyStyle={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <div
                style={{
                  background: "#fee2e2",
                  padding: "10px",
                  borderRadius: "12px",
                  marginLeft: "-120px",
                }}
              >
                <TeamOutlined style={{ color: "red", fontSize: 18 }} />
              </div>

              <div>
                <h2 style={{ margin: 0 }}>{total_users}</h2>
                <span style={{ color: "gray", fontSize: "13px" }}>
                  Total Users
                </span>
              </div>
            </div>
          </Card>
        </Col>
      </Row>

      <Card style={{ marginTop: "15px" }}>
        <Row gutter={[16, 16]} align="middle">
          <Col xs={24} md={12} lg={14}>
            <Input
              value={search_query_name}
              addonBefore={
                <Select
                  value={search_type}
                  style={{ width: 90 }}
                  onChange={(value) => {
                    set_search_type(value);

                    localStorage.setItem(
                      "campaign_search_type",
                      value
                    );

                    set_search_query_name("");

                    localStorage.setItem(
                      "campaign_search",
                      ""
                    );

                    set_current_page(1);

                    LIST_API(
                      1,
                      page_size,
                      "",
                      value
                    );
                  }}
                >
                  <Select.Option value="name">Name</Select.Option>
                  <Select.Option value="email_template_name">
                    Template
                  </Select.Option>
                  <Select.Option value="group_name">
                    Group
                  </Select.Option>
                </Select>
              }
              placeholder="Search"
              onChange={handleInput}
              size="large"
            />
          </Col>

          <Col xs={24} md={12} lg={10}>
            <Space
              wrap
              style={{
                width: "100%",
                justifyContent: "flex-end",
                display: "flex",
              }}
            >
              {selectedRowKeys.length > 0 && (
                <>
                  <Popconfirm
                    title={`Download ${selectedRowKeys.length} selected campaign(s)?`}
                    description={`Are you sure you want to download ${selectedRowKeys.length} campaign report(s)?`}
                    onConfirm={handleBulkDownload}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button
                      style={{
                        backgroundColor: "#1fa7a1",
                        color: "#fff",
                        borderColor: "#1fa7a1",
                      }}
                    >
                      <DownloadOutlined />
                      Download ({selectedRowKeys.length})
                    </Button>
                  </Popconfirm>

                  <Popconfirm
                    title={`Delete ${selectedRowKeys.length} selected campaign(s)?`}
                    description={`Are you sure you want to delete ${selectedRowKeys.length} campaign(s)?`}
                    onConfirm={handleBulkDelete}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button
                      style={{
                        backgroundColor: "#ff4d4f",
                        color: "#fff",
                        borderColor: "#ff4d4f",
                      }}
                    >
                      <DeleteFilled />
                      Delete ({selectedRowKeys.length})
                    </Button>
                  </Popconfirm>
                </>
              )}
            </Space>
          </Col>
        </Row>

        {loader ? (
          <CulsightPageLoader />
        ) : (
          <>
            {pagination_loader ? (
              <div style={{ textAlign: "center", padding: "60px" }}>
                <Spin indicator={<LoadingOutlined spin />} size="large" />
              </div>
            ) : (
              <Table
                rowSelection={rowSelection}
                columns={columns}
                pagination={false}
                dataSource={table_data}
                style={{ marginTop: "15px" }}
                rowKey="id"
              />
            )}

            {total_pages > 0 && (
              <div style={{ float: "right", marginTop: "20px" }}>
                <Pagination
                  current={current_page}
                  total={total_campaigns}
                  pageSize={page_size}
                  showSizeChanger
                  pageSizeOptions={["10", "20", "50", "100"]}
                  onChange={pagination_on_change}
                  onShowSizeChange={(page, pageSize) => {
                    set_page_size(pageSize);
                    pagination_on_change(1, pageSize);
                  }}
                  style={{ display: "inline-block" }}
                  className="no-search-pagination"
                />

                <style>
                  {`
    .no-search-pagination .ant-select-selection-search-input {
      display: none !important;
    }
  `}
                </style>
              </div>
            )}
          </>
        )}
      </Card>
    </div>
  );
}

export default Campaign;

